(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name core.factory:SessionInjectorService
   *
   * @description
   *
   */
  angular
    .module('core')
    .factory('SessionInjectorService', SessionInjectorService);

  function SessionInjectorService($rootScope, $log, $sessionStorage, ConfigService, SessionService, $q) {
    $rootScope.$on('$stateChangeSuccess', function () {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    });

    var SessionInjectorServiceBase = {};
    SessionInjectorServiceBase.request = function (config) {
      //$log.debug($sessionStorage.ct_accessToken);
      //$log.debug($sessionStorage.expires_in);


      if ($sessionStorage.ct_accessToken != null) {
        config.headers.authorization = "Bearer " + $sessionStorage.ct_accessToken;
        $log.debug("SessionInjectorService; Bearer= " + config.headers.authorization);

      }
      //else {
      //  SessionService.authorize();
      //}
      //$log.debug("SessionInjectorService; headers = " + JSON.stringify(config.headers));

      return config;
    };

    SessionInjectorServiceBase.response = function (response) {
      //console.log("Response", response);
      // No need to handle 401/403 status codes here. They are already handled in responseError function
      //if(response.status === 401 || response.status === 403) {
      //   //alert('err r');
      //  $log.debug("SessionInjectorService; Response code = " + response.status);
      //   SessionService.authorize();
      // }
      return response;
    };

    SessionInjectorServiceBase.responseError = function (response) {

      console.log("ResponseError", response);
      if (response.status === 401 || response.status === 403) {
        $log.debug("SessionInjectorService; Response error code = " + response.status);
        // Save current state before redirecting user
        SessionService.saveCurrentState();
        SessionService.authorize();
      }
      return $q.reject(response);
    };

    return SessionInjectorServiceBase;
  }
}());
